import {
  Box,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  ListItemIcon,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { UrlApiEnvasado } from "../../../../services/apirest";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AccountBoxIcon from "@mui/icons-material/AccountBox"; // Ícono para Datos
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar"; // Ícono para Vehículos
import PersonIcon from "@mui/icons-material/Person"; // Ícono para Choferes
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Collapse, Grow } from "@mui/material";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import Navbar from "../../../Navbar";
import { useLocation, useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search"; // Ícono de lupa
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import InfoIcon from "@mui/icons-material/Info";
import AddchartIcon from "@mui/icons-material/Addchart";
import { useFechas } from "../../context/FechaContext";
import DataSaverOffIcon from '@mui/icons-material/DataSaverOff';
import { esUsuarioVip, filtrarSucursalesAutorizadas } from "../utils/accesoSucursales";

// LOG EVENTOS
import { logEventos } from "../../../../services/services";


function SucursalesHipergas() {
  let navigate = useNavigate();
  let location = useLocation();

  const {
    desdeButano,
    hastaButano,
    desdePropano,
    hastaPropano,
    setDesdeButano,
    setHastaButano,
    setDesdePropano,
    setHastaPropano,
  } = useFechas();

  const [sucursalesButanoHipergas, setSucursalesButanoHipergas] = useState([]);
  const [sucursalesPropanoHipergas, setSucursalesPropanoHipergas] = useState(
    []
  );
  const [sucursalesButanoNetizar, setSucursalesButanoNetizar] = useState([]);
  const [sucursalesPropanoNetizar, setSucursalesPropanoNetizar] = useState([]);
  const [sucursalesButanoAogas, setSucursalesButanoAogas] = useState([]);
  const [sucursalesPropanoAogas, setSucursalesPropanoAogas] = useState([]);
  const [pageButano, setPageButano] = useState(0);
  const [pagePropano, setPagePropano] = useState(0);
  const rowsPerPage = 10;
  const [tablaElegida, setTablaElegida] = useState();

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  // Estado para controlar la tabla expandida (null si ambas están visibles)
  const [expandedTable, setExpandedTable] = useState(null);

  // Estado para controlar la carga
  const [loadingButano, setLoadingButano] = useState(false);
  const [loadingPropano, setLoadingPropano] = useState(false);

  // Estado para el término de búsqueda
  const [searchTermButano, setSearchTermButano] = useState("");
  const [searchTermPropano, setSearchTermPropano] = useState("");

  // Estado para controlar la visibilidad del campo de búsqueda
  const [showSearchButano, setShowSearchButano] = useState(false);
  const [showSearchPropano, setShowSearchPropano] = useState(false);

    const obtenerButanoNetizar = () => {
    setLoadingButano(true);
    fetch(
      `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/sucursalesbutano/${desdeButano} 00:00:00/${hastaButano} 23:59:59`
    )
      .then((data) => data.json())
      .then((data) => {
        setSucursalesButanoNetizar(data);
        setLoadingButano(false);
      })
      .catch(() => setLoadingButano(false));
  };

  // Fetch para Propano
  const obtenerPropanoNetizar = () => {
    setLoadingPropano(true);
    fetch(
      `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/sucursalespropano/${desdePropano} 00:00:00/${hastaPropano} 23:59:59`
    )
      .then((data) => data.json())
      .then((data) => {
        setSucursalesPropanoNetizar(data);
        setLoadingPropano(false);
      })
      .catch(() => setLoadingPropano(false));
  };

  // Ejecutar las funciones al montar el componente
  useEffect(() => {

    obtenerButanoNetizar();
    obtenerPropanoNetizar();
  }, []); // El array vacío [] asegura que esto solo se ejecute una vez al montar el componente

  useEffect(() => {
    logEventos("Panel Estadisticas Envasado", "Estadisticas envasado", "Panel Estadisticas Envasado", localStorage.getItem("user"))
  }, [])

  const updateButano = () => {
    obtenerButanoNetizar();
  };
  const updatePropano = () => {
    obtenerPropanoNetizar();
  };

  // Función para unir y ordenar los datos
const unirYOrdenarDatos = (datos) => {
  return [...filtrarSucursalesAutorizadas(datos)].sort(
    (a, b) => b.precio_promedio_por_kilo - a.precio_promedio_por_kilo
  );
};

  const butanoCombinado = unirYOrdenarDatos(
    sucursalesButanoNetizar
  );
  const propanoCombinado = unirYOrdenarDatos(

    sucursalesPropanoNetizar
  );

  // Manejar la expansión de la tabla con animación
  const handleExpand = (table) => {
    setExpandedTable(expandedTable === table ? null : table);
  };

  // Paginación
  const handleNextPage = (type) => {
    if (
      type === "butano" &&
      (pageButano + 1) * rowsPerPage < butanoCombinado.length
    ) {
      setPageButano(pageButano + 1);
    }
    if (
      type === "propano" &&
      (pagePropano + 1) * rowsPerPage < propanoCombinado.length
    ) {
      setPagePropano(pagePropano + 1);
    }
  };

  const handlePrevPage = (type) => {
    if (type === "butano" && pageButano > 0) {
      setPageButano(pageButano - 1);
    }
    if (type === "propano" && pagePropano > 0) {
      setPagePropano(pagePropano - 1);
    }
  };

  // Menú de acciones
  const handleOpenMenu = (event, row, title) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
    setTablaElegida(title);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleDatos = () => {
    navigate("/panelsucursalnetizar", {
      state: { row: selectedRow, tabla: tablaElegida },
    });
  };

  const handleFacturacion = () => {
    navigate("/facturacionsucursalnetizar", {
      state: { row: selectedRow, tabla: tablaElegida },
    });
  };

  const handleChoferes = () => {
    navigate("/chofereshipergasnetizar", {
      state: { row: selectedRow, tabla: tablaElegida },
    });
  };

  const handleVehiculos = () => {
    navigate("/movileshipergasnetizar", {
      state: { row: selectedRow, tabla: tablaElegida },
    });
  };
  const handleInfoGlobal = () => {
    navigate("/infoglobalnetizar");
  };

  const handleRanking = () => {
    if (tablaElegida === "Butano") {
      navigate("/rankingfacturasnetizar", { state: { row: selectedRow } });
    } else {
      navigate("/rankingfacturaspropanonetizar", { state: { row: selectedRow } });
    }
  };

  const handleRankingVulnerabilidad = () => {
    // if (tablaElegida === "Butano") {
    navigate("/rankingvulnerabilidadnetizar", { state: { row: selectedRow, tabla: tablaElegida } });
    // } else {
    // navigate("/rankingfacturaspropano", { state: { row: selectedRow } });
    // }
  };

  // Función para filtrar las sucursales según el término de búsqueda
  const filterSucursales = (sucursales, searchTerm) => {
    return sucursales.filter(
      (sucursal) =>
        sucursal.nombre_sucursal
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        sucursal.origen.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  // Renderizar tabla con animación y carga
  const renderTable = (
    title,
    page,
    setPage,
    sucursales,
    fechaDesde,
    fechaHasta,
    setFechaDesde,
    setFechaHasta,
    loading,
    searchTerm,
    setSearchTerm,
    showSearch,
    setShowSearch
  ) => (
    <Grow in={expandedTable === null || expandedTable === title} timeout={500}>
      <Grid
        item
        xs={expandedTable ? 12 : 6}
        sx={{
          border: "1px solid #97C6E3",
          display: expandedTable && expandedTable !== title ? "none" : "flex",
          flexDirection: "column",
          height: "100%",
          transition: "all 0.5s ease",
        }}
      >
        {/* Encabezado */}
        <Box
          sx={{
            backgroundColor: "#1F618D",
            display: "flex",
            alignItems: "center",
            justifyContent: "center", // Centra el título
            position: "relative", // Permite posicionar el botón de forma absoluta
          }}
        >
          <Typography variant="h5" color="#fff">
            {title}
          </Typography>
          <IconButton
            onClick={() => handleExpand(title)}
            sx={{
              color: "#fff",
              position: "absolute", // Lo saca del flujo y lo posiciona
              right: 8, // Lo alinea a la derecha
            }}
          >
            {expandedTable === title ? (
              <CloseFullscreenIcon sx={{ color: "#fff" }} />
            ) : (
              <OpenInFullIcon sx={{ color: "#fff" }} />
            )}
          </IconButton>
        </Box>

        {/* Filtros de fecha, buscador y botón Actualizar */}
        <Box
          sx={{
            display: "flex",
            padding: "7px",
            gap: 1,
            alignItems: "center",
            justifyContent: "space-between", // Distribuye el espacio entre los elementos
          }}
        >
          {/* Elementos alineados a la izquierda */}
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <TextField
              type="date"
              label="Desde"
              value={fechaDesde}
              onChange={(e) => setFechaDesde(e.target.value)}
              InputLabelProps={{ shrink: true }}
              size="small"
              focused
              sx={{
                width: "130px",
                "& .MuiInputBase-input": {
                  fontSize: "0.875rem", // Achica la fuente del texto dentro del TextField
                },
              }}
            />
            <TextField
              type="date"
              label="Hasta"
              value={fechaHasta}
              onChange={(e) => setFechaHasta(e.target.value)}
              InputLabelProps={{ shrink: true }}
              size="small"
              focused
              sx={{
                width: "130px",
                "& .MuiInputBase-input": {
                  fontSize: "0.875rem", // Achica la fuente del texto dentro del TextField
                },
              }}
            />
            <Button
              variant="contained"
              onClick={title === "Butano" ? updateButano : updatePropano}
              disabled={loading}
              size="small"
              sx={{
                padding: "6px 12px",
                fontSize: "0.875rem",
                textTransform: "none",
                backgroundColor: "#3f51b5",
                "&:hover": {
                  backgroundColor: "#303f9f",
                },
              }}
            >
              Actualizar
            </Button>
          </Box>

          {/* Ícono de lupa alineado a la derecha */}
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <IconButton
              onClick={() => setShowSearch(!showSearch)}
              size="small"
              sx={{ color: "#1F618D" }}
            >
              <SearchIcon />
            </IconButton>
            {/* Campo de búsqueda (se muestra solo si showSearch es true) */}
            {showSearch && (
              <TextField
                label="Buscar sucursal"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                size="small"
                sx={{
                  width: "150px",
                  "& .MuiInputBase-input": {
                    fontSize: "0.875rem", // Achica la fuente del texto dentro del TextField
                  },
                }}
              />
            )}
          </Box>
        </Box>

        {/* Tabla o animación de carga */}
        <TableContainer component={Paper} sx={{ flex: 1 }}>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px", borderRight: "1px solid #e0e0e0" }} align="center">
                    Pos.
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px", borderRight: "1px solid #e0e0e0" }} align="center">
                    Sucursal
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px", borderRight: "1px solid #e0e0e0" }} align="center">
                    $ Promedio
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px", borderRight: "1px solid #e0e0e0" }} align="center">
                    $ Max.
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px", borderRight: "1px solid #e0e0e0" }} align="center">
                    $ Min.
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px", borderRight: "1px solid #e0e0e0" }} align="center">
                    Cant. Cli.
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px", borderRight: "1px solid #e0e0e0" }} align="center">
                    Kg. Vend.
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px", borderRight: "1px solid #e0e0e0" }} align="center">
                    acc.
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filterSucursales(sucursales, searchTerm)
                  .slice(page * rowsPerPage, (page + 1) * rowsPerPage)
                  .map((sucursal, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ padding: "2.5px", borderRight: "1px solid #e0e0e0" }}>
                        {index + 1 + page * rowsPerPage}
                      </TableCell>
                      <TableCell sx={{ padding: "2.5px", borderRight: "1px solid #e0e0e0" }}>
                        {sucursal.nombre_sucursal} -{" "}
                        {
                            sucursal.origen==="netizar"?(sucursal.empresa===1?"Hipergas":"Aogas")
                            :""
                            }
                      </TableCell>
                      <TableCell sx={{ padding: "1.5px", borderRight: "1px solid #e0e0e0" }} align="right">
                        {Number(sucursal.precio_promedio_por_kilo).toFixed(2)}
                      </TableCell>
                      <TableCell
                        sx={{
                          padding: "1.5px",
                          fontWeight: "bold", borderRight: "1px solid #e0e0e0"
                        }}
                        align="right"
                      >
                        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                          {Number(sucursal.precio_maximo_por_kilo).toFixed(2)}
                        </Typography>
                      </TableCell>
                      <TableCell
                        sx={{
                          padding: "1.5px",
                          fontWeight: "bold", borderRight: "1px solid #e0e0e0"
                        }}
                        align="right"
                      >
                        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                          {Number(sucursal.precio_minimo_por_kilo).toFixed(2)}
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ padding: "1.5px", borderRight: "1px solid #e0e0e0" }} align="right">
                        {sucursal.cantidad_clientes_distintos}
                      </TableCell>
                      <TableCell sx={{ padding: "1.5px", borderRight: "1px solid #e0e0e0" }} align="right">
                        {sucursal.kilos_vendidos}
                      </TableCell>
                      <TableCell sx={{ padding: "1.5px" }}>
                        <IconButton
                          onClick={(event) =>
                            handleOpenMenu(event, sucursal, title)
                          }
                          size="small"
                        >
                          <MoreVertIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          )}
        </TableContainer>

        {/* Menú de acciones */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleCloseMenu}
        >
          <MenuItem onClick={handleDatos}>
            <ListItemIcon>
              <ZoomInIcon fontSize="small" color="primary" />
            </ListItemIcon>
            Datos
          </MenuItem>
          <MenuItem onClick={handleFacturacion}>
            <ListItemIcon>
              <ReceiptLongIcon fontSize="small" color="action" />
            </ListItemIcon>
            Facturación
          </MenuItem>
          <MenuItem onClick={handleVehiculos}>
            <ListItemIcon>
              <DirectionsCarIcon fontSize="small" color="secondary" />
            </ListItemIcon>
            Vehículos
          </MenuItem>
          <MenuItem onClick={handleChoferes}>
            <ListItemIcon>
              <PersonIcon fontSize="small" color="success" />
            </ListItemIcon>
            Choferes
          </MenuItem>
          <MenuItem onClick={handleRanking}>
            <ListItemIcon>
              <SignalCellularAltIcon fontSize="small" color="inherit" />
            </ListItemIcon>
            Ranking Facturas
          </MenuItem>
          <MenuItem onClick={handleRankingVulnerabilidad}>
            <ListItemIcon>
              <DataSaverOffIcon fontSize="small" color="primary" />
            </ListItemIcon>
            Ranking de Vulnerabilidad
          </MenuItem>
        </Menu>

        {/* Paginación */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: "3px",
            alignItems: "center",
          }}
        >
          <IconButton
            onClick={() => handlePrevPage(title.toLowerCase())}
            disabled={page === 0}
            sx={{
              color: page === 0 ? "gray" : "#1F618D",
              backgroundColor: page === 0 ? "lightgray" : "#E3F2FD",
              borderRadius: "50%",
              padding: "3px",
            }}
          >
            <ChevronLeftIcon />
          </IconButton>

          <Typography>Página {page + 1}</Typography>

          <IconButton
            onClick={() => handleNextPage(title.toLowerCase())}
            disabled={(page + 1) * rowsPerPage >= sucursales.length}
            sx={{
              color:
                (page + 1) * rowsPerPage >= sucursales.length
                  ? "gray"
                  : "#1F618D",
              backgroundColor:
                (page + 1) * rowsPerPage >= sucursales.length
                  ? "lightgray"
                  : "#E3F2FD",
              borderRadius: "50%",
              padding: "3px",
            }}
          >
            <ChevronRightIcon />
          </IconButton>
        </Box>
      </Grid>
    </Grow>
  );

  return (
    <>
      <Navbar />
      <Box sx={{ height: "82vh" }}>
        <Grid container sx={{ height: "100%" }}>
          <Grid item xs={12}>
            <Box
              sx={{
                backgroundColor: "#1F618D",
                mt: 1,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                border: "1px solid #97C6E3",
                position: "relative",
                px: 2,
                height: 35, // altura fija para que todo se alinee bien
              }}
            >
              {/* Texto a la izquierda */}
              <Typography
                variant="caption"
                sx={{ color: "#EAF2F8", fontStyle: "italic" }}
              >
                * Todos los precios están expresados sin impuestos
              </Typography>

              {/* Título centrado */}
              <Box
                sx={{
                  position: "absolute",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                <Typography variant="h5" color="#fff">
                  Sucursales
                </Typography>
              </Box>

              {/* Botón a la derecha */}
              {esUsuarioVip() && (
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleInfoGlobal}
                  sx={{
                    color: "#1F618D",
                    backgroundColor: "#E0E0E0",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#BDBDBD",
                      boxShadow: "none",
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#1F618D",
                    },
                  }}
                  startIcon={<AddchartIcon />}
                >
                  Información
                </Button>
              )}
            </Box>

          </Grid>
          {renderTable(
            "Butano",
            pageButano,
            setPageButano,
            butanoCombinado,
            desdeButano,
            hastaButano,
            setDesdeButano,
            setHastaButano,
            loadingButano,
            searchTermButano,
            setSearchTermButano,
            showSearchButano,
            setShowSearchButano
          )}
          {renderTable(
            "Propano",
            pagePropano,
            setPagePropano,
            propanoCombinado,
            desdePropano,
            hastaPropano,
            setDesdePropano,
            setHastaPropano,
            loadingPropano,
            searchTermPropano,
            setSearchTermPropano,
            showSearchPropano,
            setShowSearchPropano
          )}
        </Grid>
      </Box>
    </>
  );
}

export default SucursalesHipergas;
